<template>
  <div>
    <myDialog ref="myDialog">
      <div class="shareCenter">
        <div v-if="!nextType">
          <div class="sharetop">
            <span class="sharetit-title-text">
              开通Feemoo会员直接使用Feemoo会员下载，或绑定手机号使用福利点下载
            </span>
          </div>
          <div>
            <div class="user">
              <el-select
                v-if="codeList.length > 0"
                class="elSelect"
                popper-class="selectStyle"
                :popper-append-to-body="false"
                v-model="phoneUser.pcode"
              >
                <div
                  class="choosecountry"
                  style="color: #8a8b92; margin: 10px 0 12px 20px"
                >
                  选择国家或地区
                </div>
                <el-option
                  :label="item.tel"
                  :value="item.tel"
                  v-for="item in codeList"
                  :key="item.tel_id"
                  style="
                    width: 432px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  {{ item.name }}
                  <span>{{ item.tel }}</span>
                </el-option>
              </el-select>
              <el-input
                class="commitInput"
                :class="codeList.length > 0 ? 'isCode' : ''"
                v-model="phoneUser.phone"
                placeholder="请输入手机号"
                @focus="zhfocus"
                @blur="inputblur"
                @keyup.enter.native="nextStep()"
                autocomplete="off"
              >
              </el-input>
              <img
                v-show="userbor && phoneUser.phone"
                class="input-Close"
                :src="$utils.getPng('input-Close')"
                alt=""
              />
              <div
                v-show="phoneUser.phone"
                class="input-Close"
                @click="phoneUser.phone = ''"
              ></div>
            </div>
          </div>
        </div>
        <div v-if="nextType">
          <div class="sharetop2">
            <div class="sharetit-title">
              请输入发送至
              <span
                >{{ phoneUser.pcode }}{{ filterNumbers(phoneUser.phone) }}</span
              >
              的 <span>6</span> 位验证码有效期 3 分钟
            </div>
          </div>
          <div class="codeBox">
            <VerificationCode2
              :error="reload"
              :i-loading="loading"
              @next="next"
              @changeload="changeload"
            ></VerificationCode2>
            <div class="time" v-if="time == 60">
              <span @click="nextStep()">重新获取验证码</span>
              <span v-show="isNone == 2" @click="nextStep(2)"
                >未收到验证码？</span
              >
            </div>
            <div class="time" v-else>{{ time }}s后重新获取</div>
          </div>
        </div>
        <!-- <div
        style="padding-top: 32px;"
        class="button"
        :class="direction == left ? 'button1' : 'button2'"
      >
        <button
          class="cancel pointer btny3"
          @click="!nextType ? nextStep() : binding()"
        >
          {{ !nextType ? confirmTxt : "确定" }}
        </button>
      </div> -->
      </div>
      <div class="dialog-footer" slot="dialog-footer">
        <div v-if="!nextType" class="code-but primaryBtn" @click="openVip()">
          去开通Feemoo会员
        </div>
        <div
          v-if="!nextType"
          :class="!disabled ? 'primaryBtnDis' : ''"
          class="code-but primaryBtn"
          @click="nextStep()"
        >
          {{ confirmTxt }}
        </div>
        <el-button
          v-if="nextType"
          :class="dis_next.length != 6 ? 'primaryBtnDis' : ''"
          :loading="loading"
          class="code-but primaryBtn"
          @click="binding()"
          >确 定</el-button
        >
      </div>
    </myDialog>
  </div>
</template>
<script>
import VerificationCode2 from '@/components/VerificationCode2'
import myDialog from '@/components/dialog/myDialog1.vue'
import { getSendMsg, bindPhoneAPI, getPhonePcodeAPI } from '@/axios/home'
import { eventBus } from '@/utils/event-bus'
export default {
  name: 'Bindphone', // 绑定手机号的弹窗
  components: {
    VerificationCode2,
    myDialog,
  },
  data() {
    return {
      phoneUser: {
        pcode: '+86',
        phone: '',
      },
      identityForm: {
        codeid: {},
      },
      nextType: false,
      time: 60,
      timerA: null,
      userbor: false,
      dis_next: '',
      captchaObj: '',
      validate: '',
      reload: false,
      loading: false,
      sms_type: 0, //默认为0，未收到验证码传2
      isNone: 1,
      codeList: [], //区号list
    }
  },
  props: {
    isShow: Boolean,
    iconShow: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    state: {
      type: Number,
      default: 2,
    },
    title: String,
    tips: {
      type: String,
      required: false,
    },
    sureTxt: String,
    confirmTxt: {
      type: String,
      default: '下一步',
    },
    direction: String,
    confirmStyle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    disabled() {
      return (
        (this.phoneUser.pcode == '+86' && this.phoneUser.phone.length == 11) ||
        (this.phoneUser.pcode != '+86' && this.phoneUser.phone.length > 0)
      )
    },
  },
  methods: {
    //获取区号
    getPhonePcode() {
      getPhonePcodeAPI()
        .then(res => {
          if (res.status == 1) {
            this.codeList = res.data
          }
        })
        .catch(err => {})
    },
    filterNumbers(str) {
      // 转换为字符串

      // 获取字符串长度
      let len = str.length

      // 如果长度小于等于5，则直接返回原始字符串
      if (len <= 5) {
        return str
      }

      // 保留前三位
      let filteredStr = str.slice(0, 3)

      // 添加星号
      for (let i = 3; i < len - 2; i++) {
        filteredStr += '*'
      }

      // 保留最后两位
      filteredStr += str.slice(len - 2)

      return filteredStr
    },
    minute() {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        this.isNone = 2
        clearInterval(this.timerA)
      }
    },
    //发送验证码
    sendcode: _.debounce(
      function (captcha_verify, validate = {}) {
        if (validate == 'close') {
          return
        }
        var reg_tel =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (
          this.identityForm.pcode == '+86' &&
          !reg_tel.test(this.identityForm.nphone)
        ) {
          this.$toast('请输入正确的手机号', 2)
          return
        }
        if (this.phoneUser.phone === '') {
          this.$toast('请输入手机号', 2)
          return
        }
        if (this.phoneUser.pcode === '+86') {
          if (!/^1[3456789]\d{9}$/.test(this.phoneUser.phone)) {
            this.$toast('请输入正确的手机号', 2)
            return
          }
        }
        getSendMsg({
          pcode: this.phoneUser.pcode,
          phone: this.phoneUser.phone,
          sms_type: this.sms_type,
          lot_number: validate?.lot_number || '',
          captcha_output: validate?.captcha_output || '',
          pass_token: validate?.pass_token || '',
          gen_time: validate?.gen_time || '',
        }).then(res => {
          if (res.status == 1) {
            this.identityForm.codeid = res.data
            this.$toast(res.msg, 1)
            this.nextType = true
            // this.disabled = false
            this.timerA = setInterval(() => {
              this.minute()
            }, 1000)
          } else if (res.status == 90001) {
            this.$utils.initgt4(
              'f2cb99355c3c1db93ab5720217f697d8',
              this.sendcode
            )
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    setVisible() {
      clearInterval(this.timerA)
      this.getPhonePcode()
      this.$reporte.setReporteTwo('C/1-5-10-210')
      this.phoneUser = {
        pcode: '+86',
        phone: '',
      }
      this.time = 60
      this.nextType = false
      this.userbor = false
      this.reload = false
      //   this.temp.username = ''
      //   this.temp.idCard = ''
      this.$refs.myDialog.show({
        title: '绑定手机号或开通Feemoo会员',
        icon: 'web4/icon-circle-fill',
        showClose: true,
      })
    },
    zhfocus() {
      this.userbor = true
    },
    inputblur() {
      this.userbor = false
    },
    binding: _.debounce(
      function () {
        if (this.dis_next.length < 6) {
          return
        }
        this.nextApi(this.dis_next.join(''))
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    openVip() {
      window.open(this.$glb.feemooUrl + '/vip')
    },
    nextStep(row) {
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!this.disabled) {
        return
      }
      if (
        this.phoneUser.pcode == '+86' &&
        !reg_tel.test(this.phoneUser.phone)
      ) {
        this.$toast('请正确输入手机号', 2)
        return
      } else {
        if (row) {
          this.sms_type = row
        } else {
          this.sms_type = 0
        }
        this.sendcode()
      }
    },
    handleClose() {
      this.$emit('handleClose')
    },
    handleSure() {
      this.$emit('handleSure')
    },
    //获取验证码之后的验证码
    next(val) {
      const str = val && val.toString().replace(/,/g, '')
      this.nextApi(str)
    },
    nextApi(str) {
      this.loading = true
      bindPhoneAPI({
        pcode: this.phoneUser.pcode,
        phone: this.phoneUser.phone,
        msgid: this.identityForm.codeid,
        ucode: str,
      }).then(res => {
        this.loading = false
        if (res.status) {
          this.$toast(res.msg, 1)
          eventBus.$emit('getUser')
          this.$refs.myDialog.close()
        } else {
          this.reload = true
          this.$toast(res.msg, 2)
        }
      })
    },
    changeload(val) {
      this.dis_next = val
    },
  },
}
</script>
<style lang="scss" scoped>
.choosecountry {
  font-size: 14px;
  font-weight: 400;
  margin: 15px 0 10px 20px;
  @include useTheme {
    color: getVar('text-color13-8a8b92');
  }
}

.country {
  display: flex;
  justify-content: space-between;
  width: 379px !important;
}
.user {
  position: relative;
  .input-Close {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    cursor: pointer;
  }
  width: 100%;
  height: 40px;
  border-radius: 10px;
  display: flex;
  box-sizing: border-box;
  ::v-deep .commitInput {
    .el-input__inner {
      height: 40px !important;
      border-radius: 20px;
      padding: 9px 40px 9px 16px !important;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      border: 1px solid transparent;
      white-space: pre-wrap;
      word-break: break-all;
      overflow-y: auto !important;
      // transition: padding-left 0.2s;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
        caret-color: getVar('primary-color');
        background: getVar('bg-color16-f4f6f8');
      }
      &::placeholder {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        @include useTheme {
          color: getVar('text-color6-b8bec4');
        }
      }
      &:hover {
        @include useTheme {
          border: 1px solid getVar('primary-color');
        }
      }
      &:focus {
        transition: padding-left 0.2s;
        padding-left: 16px;
        @include useTheme {
          outline: 2px solid getVar('primary-color4');
          border: 1px solid getVar('primary-color');
          background: getVar('bg-color11-ffffff');
        }
      }
    }
  }
  ::v-deep .isCode {
    .el-input__inner {
      padding-left: 70px !important;
    }
  }
  ::v-deep .elSelect {
    position: absolute;
    width: 70px;
    z-index: 1;
    .el-input {
      .el-input__inner {
        background: transparent !important;
        border: none;
        padding-right: 0;
        padding-left: 12px;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
      }
    }
  }
}
.user:nth-child(2) {
  margin-bottom: 11px;
}

.user1 {
  display: flex;
  justify-content: space-between;

  .rember {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    @include useTheme {
      color: getVar('text-color13-8a8b92');
    }
    .remberbox {
      margin-right: 8px;
      width: 16px;
      height: 16px;

      .imgg {
        width: 16px;
        height: 16px;
      }

      .notg {
        width: 15px;
        height: 15px;
        border-radius: 3px;
        @include useTheme {
          border: 1px solid getVar('border-color1');
        }
      }
    }
  }

  .forget {
    font-size: 14px;

    font-weight: 400;
    @include useTheme {
      color: getVar('primary-color');
    }
  }
}
.time {
  //   width: 84px;
  margin-top: 16px;
  margin-left: 15px;
  height: 18px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 15px;
  @include useTheme {
    color: getVar('primary-color');
  }
  span {
    cursor: pointer;
  }
}
.shareCenter {
  width: 100%;
}
.sharetop {
  margin-bottom: 16px;
}
.sharetop2 {
  margin-bottom: 22px;
}
.sharetit-title-text {
  //   width: 168px;
  height: 22px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  @include useTheme {
    color: getVar('text-color1-2c2c2c');
  }
}
.sharetit-title {
  // width: 360px;
  height: 22px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  @include useTheme {
    color: getVar('text-color13-8a8b92');
  }
  span {
    @include useTheme {
      color: getVar('text-color1-2c2c2c');
    }
  }
}
.primaryBtn {
  background: rgba(246, 121, 66, 0.3);
  border-radius: 18px;
  cursor: pointer;
  display: inline-block;
  // font-family: Noto Sans SC;
  color: #fff;
  text-align: center;
  border: none;
  &:hover {
    background: rgba(246, 121, 66, 0.3);
  }
  &:active {
    background: rgba(246, 121, 66, 0.3);
  }
}
.btnok {
  cursor: pointer;
  @include useTheme {
    background: getVar('primary-color') !important;
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.code-but {
  display: inline-block;
  padding: 5px 16px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
  box-sizing: border-box;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.code-but + .code-but {
  margin-left: 12px;
}
</style>
